import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tracking-page-simple-tracker',
  templateUrl: './tracking-page-simple-tracker.component.html',
  styleUrls: ['./tracking-page-simple-tracker.component.scss', '../../../tracking-page.component.scss'],
  standalone: false,
})
export class TrackingPageSimpleTrackerComponent implements OnInit {
  @Input() unsuccessfulTrackingStatusColorPreviewButtonState!: boolean;
  @Input() formGroup: FormGroup;
  @Output() previewUnsuccessfulTrackingColorClicked = new EventEmitter<Event>();

  constructor() {}

  ngOnInit(): void {}

  previewUnsuccessfulTrackingStatusColorClicked(event: Event): void {
    event.stopPropagation();
    this.previewUnsuccessfulTrackingColorClicked.emit(event);
  }
}
